export default __webpack_public_path__ + "static/media/backgroundutama.f3ba7173.png";